import React, { forwardRef } from "react";
import "./PrintAudit.style.css";
import HeaderSection from "./components/HeaderSection";
import AuditDetailsSection from "./components/AuditDetailsSection";
import ActivityListSection from "./components/ActivityListSection";
import FooterSection from "./components/FooterSection";

const PrintAuditComponent = forwardRef(({ PreviewData, CompanyInfo }, ref) => {
  const { activityList } = PreviewData;
  return (
    <div className="print-wp-main-div px-4 py-2" ref={ref}>
      <div className="no-break">
        <div className="spacer" />
        <HeaderSection CompanyInfo={CompanyInfo} />
      </div>
      <div className="no-break">
        <AuditDetailsSection
          Details={PreviewData ? { ...PreviewData, ...CompanyInfo } : {}}
        />
      </div>
      <div className="page-break">
        <div className="spacer" />
        <ActivityListSection ActivityData={activityList || []} />
      </div>
      <div className="no-break">
        <FooterSection Details={PreviewData ? PreviewData : {}} />
      </div>
    </div>
  );
});

export default PrintAuditComponent;